import { useState } from 'react';
import ManageAppTabs from "./manageAppTabs";

export default function useReviewerTabs(onTabClose) {
    const firstTab = { label: "REVIEWERS", selected: true };
    const [tabs, setTabs] = useState([firstTab]);
    
    function addTab(reviewerEmployeeId, label, index) {
        setTabs(currentTabs => {
            index = index ?? currentTabs.findIndex(tab => reviewerEmployeeId === tab.reviewerEmployeeId);

            if (index > -1) { // Switch to a reviewer's tab if it's already open
                const tabsCopy = JSON.parse(JSON.stringify(currentTabs));
                tabsCopy.forEach(tab => tab.selected = false);
                tabsCopy[index].selected = true;
                return tabsCopy;
            }

            return [ ...currentTabs, { reviewerEmployeeId, label, selected: false } ];
        });
    }
    
    function closeTab(indexToRemove) {
        // Call the callback before closing the tab
        if (onTabClose) {
            onTabClose();
        }
        
        setTabs(currentTabs => {
            const tabsCopy = JSON.parse(JSON.stringify(currentTabs)).filter((_tab, index) => index !== indexToRemove);
            if (!tabsCopy.find(tab => tab.selected)) { tabsCopy[0].selected = true; } // Make sure at least 1 is selected
            return tabsCopy;
        });
    }
    
    function showTab(index) { addTab(undefined, undefined, index); }
    
    return { tabs, addTab, ManageAppTabs: ( <ManageAppTabs tabs={tabs} closeTab={closeTab} showTab={showTab} /> ) };
}
